export default __webpack_public_path__ + "static/media/32.0147183a.jpeg";